module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/arrow-oblique-540765f3a7137929609765eb2effb9a0.svg";